<app-confirm [title]="title" [status]="status" [accent]="accent" (onResult)="onResultConfirm($event)">
  {{body}}
</app-confirm>

